/*
 * @Author: Lemon C
 * @Date: 2024-06-13 18:07:34
 * @LastEditTime: 2024-06-14 10:11:45
 */

import router from '@/router';

export const PiniaPlugin = (({ store }) => {
    store.router = router;
    store.route = router.currentRoute;
});